module.exports = __webpack_public_path__ + "static/img/kangjia.f74b24ac.jpg";